<template>
  <div class="container">
    <h2 class="mb-5">Manage countries</h2>
    <div class="text-right mb-3">
      <base-button radius="tr" component-class="green filled" @click.native="add">
        <i class="fas fa-plus-circle mr-3"></i> ADD
      </base-button>
    </div>

    <async-wait :init="{dispatch: 'countries/getCountries', getter: 'countries/countries'}">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th style="width: 130px;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="country in countries" :key="country.id">
            <td>
              <a title="Edit country" href="javascript:;" @click="edit(country)">{{ country.name }}</a>
            </td>
            <td>
              <span class="action-icon" @click="toggleVisibility(country)" title="Hide language">
                <i class="fas fa-trash"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </async-wait>

    <base-button radius="bl" component-class="blue" @click.native="back">
      <i class="fas fa-arrow-left mr-3"></i> Back
    </base-button>

  </div>
</template>

<script>

  import BaseButton from '@/components/inputs/button/BaseButton';
  import AsyncWait from '@/components/async-wait/AsyncWait';

  export default {
    name: 'CountryList',
    mounted () {

    },
    methods: {
      add() {
        this.$store.dispatch('countries/current', {}).then(() => {
          this.$router.push({name: 'user.manage-countries-new'});
        });
      },
      edit(country) {
        // eslint-disable-next-line
        this.$store.dispatch('countries/current', deepCopy(country)).then(e => {
          this.$router.push({name: 'user.manage-countries-show', params: { code: country.code }});
        });
      },
      toggleVisibility (country) {
        // eslint-disable-next-line
        let t = deepCopy(country);
        t.visible = !t.visible;
        this.$store.dispatch('countries/save', {oldCode: t.code, country: t}).then(() => {
          this.$snotify.success('Visibility saved.');
          this.$router.push({name: 'user.manage-countries'});

          this.$store.dispatch('countries/getCountries');
        });
      },
      back() {
        this.$router.push({name: 'user.dashboard'});
      }
    },
    watch: {
    },
    data() {
      return {

      };
    },
    computed: {
      countries: {
        get () {
          return this.$store.getters['countries/countries'];
        },
        set (value) {
          this.$store.commit('countries/countries', value);
        }
      }
    },
    components: {
      'base-button': BaseButton,
      'async-wait': AsyncWait,
    }
  };

</script>
